import { render, staticRenderFns } from "./WorkshopEdit.vue?vue&type=template&id=0f76eae4&"
import script from "./WorkshopEdit.vue?vue&type=script&lang=js&"
export * from "./WorkshopEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports